module.exports = __webpack_public_path__ + "img/icon.39c48281.png";